function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "arrow_back",
  d: "M12,52H74.344L52.888,73.456a4,4,0,1,0,5.657,5.656L86.828,50.828h0a4.037,4.037,0,0,0,.5-.609c.067-.1.114-.21.172-.315a4,4,0,0,0,.195-.373,3.557,3.557,0,0,0,.129-.415c.033-.111.076-.217.1-.331A4,4,0,0,0,88,48h0s0-.006,0-.009a4.032,4.032,0,0,0-.078-.774c-.024-.12-.069-.231-.1-.349a3.715,3.715,0,0,0-.123-.4,4.142,4.142,0,0,0-.208-.4c-.054-.1-.1-.2-.159-.292a3.941,3.941,0,0,0-.5-.614L58.544,16.888a4,4,0,1,0-5.657,5.657L74.343,44H12a4,4,0,0,0,0,8Z",
  transform: "translate(-8 -15.716)"
});

function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 64.567,
    viewBox: "0 0 80 64.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.c764a74d.svg";
export { ForwardRef as ReactComponent };